export default "__VITE_ASSET__ZfoiNbs7__"